import Vue from 'vue'
import axios from 'axios'
import { HTTP } from '@/utils/http-common'
import VueCookies from 'vue-cookies'
import { getValidationErrors } from '../../../../../utils/auth'

export default {
    list (parent, page) {
        if (page === 0) {
            return HTTP.get('/gateway/api/manage/')
        } else if (page !== null) {
            return HTTP.get(page)
        } else {
            return {}
        }
    },
    get (apiName) {
        return HTTP.get(`/gateway/api/manage/${apiName}/`)
    },
    delete (name, parent) {
        return new Promise((resolve, reject) => {
            return HTTP.delete('/gateway/api/manage/' + name + '/')
                .then((response) => {
                    parent.$store.commit('push', { msg: 'Api deleted', color: 'success' })
                    return resolve(response)
                }).catch((error) => {
                    parent.$store.commit('push', { msg: 'Error when deleting the api', color: 'error' })
                    return reject(error)
                })
        })
    },
    create (api, parent) {
        api.is_global = false
        api.project_id = parent.$route.params.project
        return new Promise((resolve, reject) => {
            return HTTP.post('/gateway/api/manage/',
                api
            ).then((response) => {
                return resolve(response)
            }).catch((error) => {
                // getValidationErrors(parent, error);

                if (!error.response.data.error) {
                    let errorMessage = ''
                    for (let i = 0; i < error.response.data.error.length; i++) {
                        if (i > 0) {
                            errorMessage += '\n'
                        }
                        if (error.response.data.error[i].includes('already exists')) {
                            parent.errors.add('name', error.response.data.error[i])
                        }
                        errorMessage += error.response.data.error[i]
                    }
                    parent.$store.commit('push', { msg: errorMessage, color: 'error' })
                } else {
                    parent.$store.commit('push', { msg: '' + error, color: 'error' })
                }
                return reject(error)
            })
        })
    },

    /* INTEGRATION */
    get_api_embed (name, parent) {
        return HTTP.get('/gateway/api/api/' + name + '/apiembed/')
    },

    /* CALL API */
    call_api (name, parent) {
        return HTTP.get('/gateway/api/manage/' + name + '/execute/')
    },

    /* MANAGE PERMISSIONS */
    update (api, parent) {
        return HTTP.put('/gateway/api/manage/' + api.name + '/', api).catch((error) => {
            console.log(error)
            parent.$store.commit('push', { msg: 'Error ' + error.response.status + ' detected', color: 'error' })
        })
    },
    addPermission (parent, api, user, permission) {
        if (typeof (api.permissions.find(x => x.username === user)) !== 'undefined') {
            parent.$store.commit('push', { msg: 'User already in the team' + ' detected', color: 'error' })
        } else {
            HTTP.post('permissions/api/' + api.name + '/', {
                username: user,
                perms: permission,
            }).then((response) => {
                parent.$store.commit('push', { msg: 'Invite sent', color: 'success' })
                parent.$emit('modifyPermissions', { type: 'addPermission', user: user, permission: permission })
            }).catch((error) => {
                if (error.response.status === 404) {
                    parent.$store.commit('push', { msg: 'Username does not exist', color: 'error' })
                }
            })
        }
    },
    changePermission (parent, api, user, permission) {
        HTTP.post('permissions/api/' + api.name + '/', {
            username: user,
            perms: permission,
        }).then((response) => {
            parent.$store.commit('push', { msg: 'Permissions updated', color: 'success' })
            parent.$emit('modifyPermissions', { type: 'changePermission', user: user, permission: permission })
        }).catch((error) => {
            if (error.response.status === 404) {
                parent.$store.commit('push', { msg: 'Username does not exist', color: 'error' })
            }
        })
    },
    deletePermission (parent, api, user) {
        HTTP.delete('permissions/api/' + api.name + '/username/' + user.username + '/')
            .then((response) => {
                parent.$store.commit('push', { msg: 'permission deleted', color: 'success' })
                parent.$emit('modifyPermissions', { type: 'deletePermission', user: user })
            }).catch((error) => {
                parent.$store.commit('push', { msg: 'Error when deleting the user\'s permissions', color: 'error' })
            })
    },
    getMetrics (parent, name, refresh = false) {
        var metrics_url = 'metrics/api/' + name + '/weekly/'
        if (refresh) { metrics_url = 'metrics/api/' + name + '/weekly_refresh/' }
        return HTTP.get(metrics_url)
    },
    searchUsers (search, parent) {
        return HTTP.get('/permissions/users/search/?username=' + search)
    },
}
